import * as React from "react"
import { useEffect } from "react"
import { useParams } from "react-router"
import { Link } from "react-router-dom"
import { Helmet } from "react-helmet-async"
import { useSignal } from "@preact/signals-react"
import { Box, Grid } from "@mui/material"
import { ImageSeeker } from "@ui-seeker/core"

import BannersIframe from "./Iframe"


export default function BannersViewScreenshotPage () {
    const { idSearch } = useParams()

    const loadingIframe = useSignal(true)

    useEffect(() => {
        if (loadingIframe.value) setTimeout(() => loadingIframe.value = false, 500)
    }, [])

    return <Box width={1} height="100vh" sx={{ background: "rgb(208,202,194)" }}>
        <Helmet>
            <title>View Screenshot</title>
            <link rel="shortcut icon" href="/icons/puig-loco-new.ico" type="image/x-icon" />
        </Helmet>
        <Box position="relative" textAlign="center">
            <Grid container spacing={1} sx={{alignItems: 'center', justifyContent: 'center', height: '100%'}}>
                <Grid item xs={12} sx={{ mb: "-60px" }}>
                        <Link href='/dashboard' target="_blank" sx={{cursor: 'pointer'}}>
                            <ImageSeeker src="/logos/puig-logo-new-text.png" height={70}/>
                        </Link>
                </Grid>
                <Grid item xs={12} sx={{ background: "rgb(208,202,194)" }}>
                    <BannersIframe isLoading={loadingIframe.value} type="v2/sov" idSearch={idSearch}/>
                </Grid>
            </Grid>
        </Box>
    </Box>
}